import { useState, useEffect } from "react";
import { baseurl } from "../functions/constants";
import { datosWorker } from "../functions/WorkersQueries";

const DatosWorker = ({ id, setVerDatosWorker }) => {
	const [worker, setWorker] = useState("");
	const [inePath1, setInePath1] = useState("");
	const [inePath2, setInePath2] = useState("");

	useEffect(() => {
		datosWorker(id, setWorker);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id]);

	useEffect(() => {
		setInePath1(`${baseurl}/${worker.ine1}`);
		setInePath2(`${baseurl}/${worker.ine2}`);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [worker]);

	return (
		<>
			<div className="flex flex-row justify-center text-center text-xl font-semibold text-sky-700 mt-8">
				{worker?.nombre
					? `Identificación de ${worker.nombre}`
					: "No se encuentra identificación al respecto"}
			</div>

			<div className="max-w-full h-auto mx-auto p-8">
				{inePath1.length && (
					<img
						src={inePath1}
						alt="INE anverso"
						className="border-2 rounded-xl"
					/>
				)}
			</div>
			<hr />
			<div className="max-w-full h-auto mx-auto p-8">
				{inePath2.length && (
					<img
						src={inePath2}
						alt="INE reverso"
						className="border-2 rounded-xl"
					/>
				)}
			</div>

			<div className="flex flex-row justify-center">
				<button
					className="mx-auto bg-gray-500 text-white rounded-xl py-1 px-3 hover:bg-slate-400 hover:text-black hover:duration-500"
					onClick={() => setVerDatosWorker(0)}
				>
					Cerrar
				</button>
			</div>
		</>
	);
};

export default DatosWorker;
